module.exports = __webpack_public_path__ + "img/63fddb7f6f5f4c5da930abd8509b5c6.b9959d29.png";